// ═══ 모바일 뷰포트 훅 — 말소대행 반응형 (2026-08-13) ═══
// 셸 CSS(App.css) 의 768px 브레이크포인트와 동일 기준. 인라인 스타일 화면들의 분기용.
// 사용: var isMobile = useIsMobile();  →  style/구조 분기. 데스크탑 렌더는 절대 바꾸지 않는다.
import { useState, useEffect } from 'react';

var QUERY = '(max-width: 768px)';

export function useIsMobile() {
  var mq = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(QUERY) : null;
  var st = useState(mq ? mq.matches : false);
  var isMobile = st[0], setIsMobile = st[1];
  useEffect(function () {
    if (!mq) return undefined;
    var on = function (e) { setIsMobile(e.matches); };
    if (mq.addEventListener) mq.addEventListener('change', on);
    else mq.addListener(on);
    return function () {
      if (mq.removeEventListener) mq.removeEventListener('change', on);
      else mq.removeListener(on);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return isMobile;
}

// 표를 그대로 두고 가로 스크롤만 허용할 때의 래퍼 스타일 (페이지 가로 스크롤 금지 원칙)
export var hScroll = { overflowX: 'auto', WebkitOverflowScrolling: 'touch', maxWidth: '100%' };
